export default function mapFiltersName(filter: string): string {
  if (!filter) {
    return ''
  }

  switch (filter.toLowerCase()) {
    case 'manual check':
      return 'processing'
    case 'monthly interest':
      return 'loan_interest'
    case 'interest':
      return 'saving_interest'
    case 'top up':
      return 'top_up'
    case 'collateral':
      return 'collateral_capital'
    case 'repayment':
      return 'repayment_status'
    case 'loan event':
      return 'loan_event'
    case 'hourly_interest':
      return 'hourly_interest'

    default:
      return filter.toLowerCase()
  }
}
